import * as React from "react";
import { AnalyticsTrigger } from "../../helpers/analytics/analytics-trigger/analytics-trigger.mjs";
import { Button } from "../../button/button.mjs";
import { FormHelper } from "../form-helper/form-helper.mjs";
import "debounce";
import "tabbable";
import { useResponsiveProps } from "../../helpers/helper/hooks/use-responsive-props.mjs";
import { useLabels } from "../../helpers/label-provider/use-labels.mjs";
const LargeSearch = (props) => {
  const { responsive, ...rest } = props;
  return responsive ? /* @__PURE__ */ React.createElement(LargeSearchResponsive, { ...rest, responsive }) : /* @__PURE__ */ React.createElement(LargeSearchAnalytics, { ...rest });
};
const LargeSearchResponsive = (props) => {
  const { responsive, ...rest } = props;
  const responsiveProps = useResponsiveProps({ responsive });
  return /* @__PURE__ */ React.createElement(LargeSearchAnalytics, { ...rest, ...responsiveProps });
};
const LargeSearchAnalytics = (props) => {
  return /* @__PURE__ */ React.createElement(
    AnalyticsTrigger,
    {
      trigger: {
        callback: "onSubmit",
        id: "Search - Submit - ".concat(props.id),
        elementId: props.id,
        elementType: "search",
        interactionType: "submit"
      }
    },
    /* @__PURE__ */ React.createElement(LargeSearchInner, { ...props })
  );
};
const LargeSearchInner = (props) => {
  const labels = useLabels();
  const { align = "center", multiline = false } = props;
  const BEM = () => {
    const classArray = ["large-search", "large-search--".concat(align)];
    if (!multiline) {
      classArray.push("large-search--single-line");
    }
    if (props.className) {
      classArray.push(props.className);
    }
    return classArray.join(" ");
  };
  const getFields = () => {
    const children = React.Children.toArray(props.children).filter(React.isValidElement);
    return children.map((child, index) => {
      var _a;
      return /* @__PURE__ */ React.createElement("div", { key: (_a = child.props.id) != null ? _a : index, className: "large-search__block" }, child);
    });
  };
  const onSubmit = (event) => {
    var _a;
    props.onSubmit && props.onSubmit(event);
    ((_a = props.formAttributes) == null ? void 0 : _a.onSubmit) && props.formAttributes.onSubmit(event);
  };
  const getSubmit = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
    const hasButtonText = (_d = (_c = (_a = props.submitButton) == null ? void 0 : _a.iconLeft) != null ? _c : (_b = props.submitButton) == null ? void 0 : _b.iconRight) != null ? _d : multiline;
    const icon = !hasButtonText ? "#search" : void 0;
    const type = (_f = (_e = props == null ? void 0 : props.submitButton) == null ? void 0 : _e.type) != null ? _f : "expressive";
    const text = (_h = (_g = props == null ? void 0 : props.submitButton) == null ? void 0 : _g.text) != null ? _h : labels.get("search.submit");
    return /* @__PURE__ */ React.createElement(
      Button,
      {
        icon,
        iconRight: (_k = (_i = props.submitButton) == null ? void 0 : _i.iconRight) != null ? _k : hasButtonText && !((_j = props.submitButton) == null ? void 0 : _j.iconLeft) ? "#search" : void 0,
        type,
        text,
        ...props.submitButton,
        className: "large-search__action",
        attributes: { type: "submit" }
      }
    );
  };
  return /* @__PURE__ */ React.createElement("form", { className: BEM(), ...props.formAttributes, onSubmit, id: props.id }, /* @__PURE__ */ React.createElement("div", { className: "large-search__inner" }, /* @__PURE__ */ React.createElement("div", { className: "large-search__fields" }, props.children && getFields()), getSubmit()), !!props.helper && /* @__PURE__ */ React.createElement(FormHelper, { className: "large-search__help", ...props.helper }));
};
export {
  LargeSearch
};
